{
  "generated_at": "static",
  "source_path": "datasets/feminism_argument_item_bank.json",
  "totals": {
    "all": 66,
    "key": 48,
    "filler": 12,
    "anchor": 6
  },
  "items": [
    {
      "family_id": "FAM001",
      "item_id": "FAM001_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW001"
      ],
      "topic_cluster": "bride_price_marriage_cost",
      "fallacy_type": "hasty_generalization",
      "argument_skeleton": "anecdote_or_limited_cases_to_group_claim",
      "statement_text": "近年20万彩礼却闪婚闪离，婚前谈崩等彩礼谈崩的案例，已经足以说明，很多男的说到给彩礼就心疼钱，却觉得老婆婚后一辈子的辛苦付出，本来就该免费白给。",
      "issue_note": "目标谬误：hasty_generalization",
      "char_count": 72,
      "read_seconds_target": 8,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": true,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM001",
      "item_id": "FAM001_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW002"
      ],
      "topic_cluster": "bride_price_marriage_cost",
      "fallacy_type": "hasty_generalization",
      "argument_skeleton": "anecdote_or_limited_cases_to_group_claim",
      "statement_text": "近年攀枝花61万彩礼，以及婚骗等天价彩礼新闻，已经足以说明，现在很多女性谈婚姻时，脑子都先算能从男性身上拿到多少",
      "issue_note": "目标谬误：hasty_generalization",
      "char_count": 56,
      "read_seconds_target": 7,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": true,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM002",
      "item_id": "FAM002_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW003"
      ],
      "topic_cluster": "bride_price_marriage_cost",
      "fallacy_type": "false_causation",
      "argument_skeleton": "single_factor_or_correlation_to_causal_claim",
      "statement_text": "高价彩礼持续走高，说白了就是婚姻里得不到尊重和保障，女性才不得不把彩礼当成最后的安全感；彩礼越贵，越说明女性在婚姻里越不被当回事。",
      "issue_note": "目标谬误：false_causation",
      "char_count": 65,
      "read_seconds_target": 8,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM002",
      "item_id": "FAM002_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW004"
      ],
      "topic_cluster": "bride_price_marriage_cost",
      "fallacy_type": "false_causation",
      "argument_skeleton": "single_factor_or_correlation_to_causal_claim",
      "statement_text": "高价彩礼持续走高，正说明女权思想把婚姻带偏了，让女人把结婚当成跟男人谈条件、漫天要价的买卖市场。",
      "issue_note": "目标谬误：false_causation",
      "char_count": 48,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM003",
      "item_id": "FAM003_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW005"
      ],
      "topic_cluster": "bride_price_marriage_cost",
      "fallacy_type": "ad_hominem",
      "argument_skeleton": "source_attack_or_motive_dismissal",
      "statement_text": "一个男人动不动就把彩礼骂成“买卖人口”，他本身就是传统婚姻模式里占便宜的那一方，有什么资格指责高彩礼？这种人的话根本不值得当真。",
      "issue_note": "目标谬误：ad_hominem",
      "char_count": 64,
      "read_seconds_target": 8,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM003",
      "item_id": "FAM003_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW006"
      ],
      "topic_cluster": "bride_price_marriage_cost",
      "fallacy_type": "ad_hominem",
      "argument_skeleton": "source_attack_or_motive_dismissal",
      "statement_text": "凡是张口闭口都把彩礼说成“女性保障”的人，多半是在变相给天价彩礼撑腰、找理由，这种人嘴里说的婚姻公平，根本信不过。",
      "issue_note": "目标谬误：ad_hominem",
      "char_count": 57,
      "read_seconds_target": 7,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM004",
      "item_id": "FAM004_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW007"
      ],
      "topic_cluster": "bride_price_marriage_cost",
      "fallacy_type": "referential_scope",
      "argument_skeleton": "disqualifying_critic_by_identity_or_benefit_scope",
      "statement_text": "一边享受前辈争来的婚姻自由，却把女性谈彩礼说成拜金，这种女生有资格批评当代女性？",
      "issue_note": "目标谬误：referential_scope",
      "char_count": 40,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM004",
      "item_id": "FAM004_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW008"
      ],
      "topic_cluster": "bride_price_marriage_cost",
      "fallacy_type": "referential_scope",
      "argument_skeleton": "disqualifying_critic_by_identity_or_benefit_scope",
      "statement_text": "住在男人买的房里、靠着男人养家的那批人，反过来说反对高彩礼就是厌女，哪来的资格批评男人？",
      "issue_note": "目标谬误：referential_scope",
      "char_count": 44,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM005",
      "item_id": "FAM005_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW009"
      ],
      "topic_cluster": "child_surname",
      "fallacy_type": "hasty_generalization",
      "argument_skeleton": "anecdote_or_limited_cases_to_group_claim",
      "statement_text": "最近好几起孩子跟妈姓闹矛盾的新闻，看得出来多数男人从心底里就不能接受女人有平等的冠姓权。",
      "issue_note": "目标谬误：hasty_generalization",
      "char_count": 44,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": true,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM005",
      "item_id": "FAM005_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW010"
      ],
      "topic_cluster": "child_surname",
      "fallacy_type": "hasty_generalization",
      "argument_skeleton": "anecdote_or_limited_cases_to_group_claim",
      "statement_text": "又看到几件随母姓上热搜的事，感觉现在多数女人都把孩子跟谁姓，当成要压男人一头、抢家庭地位的武器。",
      "issue_note": "目标谬误：hasty_generalization",
      "char_count": 48,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": true,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM006",
      "item_id": "FAM006_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW011"
      ],
      "topic_cluster": "child_surname",
      "fallacy_type": "ad_hominem",
      "argument_skeleton": "source_attack_or_motive_dismissal",
      "statement_text": "一个坚持孩子必须随父姓的男人，本来就受父权好处最多，他谈家庭传统，谈随姓原因根本不值得认真听。",
      "issue_note": "目标谬误：ad_hominem",
      "char_count": 47,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM006",
      "item_id": "FAM006_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW012"
      ],
      "topic_cluster": "child_surname",
      "fallacy_type": "ad_hominem",
      "argument_skeleton": "source_attack_or_motive_dismissal",
      "statement_text": "一个把孩子随母姓说成绝对进步的人，多半只是想拿孩子做立场表演，她谈女权根本不可信。",
      "issue_note": "目标谬误：ad_hominem",
      "char_count": 41,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM007",
      "item_id": "FAM007_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW013"
      ],
      "topic_cluster": "child_surname",
      "fallacy_type": "referential_scope",
      "argument_skeleton": "disqualifying_critic_by_identity_or_benefit_scope",
      "statement_text": "这些女生享受母亲们争来的受教育与婚姻选择空间，却反过来否定随母姓讨论，这种人有什么资格批评女性议题？",
      "issue_note": "目标谬误：referential_scope",
      "char_count": 50,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM007",
      "item_id": "FAM007_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW014"
      ],
      "topic_cluster": "child_surname",
      "fallacy_type": "referential_scope",
      "argument_skeleton": "disqualifying_critic_by_identity_or_benefit_scope",
      "statement_text": "这些女性享受父辈承担生活压力、累计资源的现实，却把支持随父姓的人都说成压迫，这样的人有资格批评传统和男性角色？",
      "issue_note": "目标谬误：referential_scope",
      "char_count": 55,
      "read_seconds_target": 7,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM008",
      "item_id": "FAM008_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW015"
      ],
      "topic_cluster": "feminism_public_expression",
      "fallacy_type": "referential_scope",
      "argument_skeleton": "disqualifying_critic_by_identity_or_benefit_scope",
      "statement_text": "现在总有一群自称中立的人，一边享受着前人拼出来的成果，一边大声说她们太极端。当年为投票权坐牢的，打破职场天花板挨骂的，在舆论风暴里、在权力边缘冲在最前面的，有几个是温和派？对这些人连基本的感谢都没有，凭什么去定义别人该怎么抗争，还好意思说自己理性？",
      "issue_note": "目标谬误：referential_scope",
      "char_count": 124,
      "read_seconds_target": 14,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": false,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM008",
      "item_id": "FAM008_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW016"
      ],
      "topic_cluster": "feminism_public_expression",
      "fallacy_type": "referential_scope",
      "argument_skeleton": "disqualifying_critic_by_identity_or_benefit_scope",
      "statement_text": "以杨笠为首的那批人，一边享受普通男性用命筑起的社会防线，一边大放厥词说男人“普通且自信”。零下四十度守边疆的，爬上万伏电塔抢修的，狂风暴雨里救灾的有没有这些女性？她们有什么资格挑衅全体男性，还叫嚣什么“冒犯的艺术”？",
      "issue_note": "目标谬误：referential_scope",
      "char_count": 108,
      "read_seconds_target": 12,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM009",
      "item_id": "FAM009_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW017"
      ],
      "topic_cluster": "employment_marriage_market",
      "fallacy_type": "hasty_generalization",
      "argument_skeleton": "anecdote_or_limited_cases_to_group_claim",
      "statement_text": "每多生一个孩子，女性年收入就下降17%；将近一半女性面试时被直接问婚育状况，有情况会面临歧视——所有企业早就默认，女人一生孩子就不值得长期培养了。",
      "issue_note": "目标谬误：hasty_generalization",
      "char_count": 73,
      "read_seconds_target": 9,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": true,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM009",
      "item_id": "FAM009_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW018"
      ],
      "topic_cluster": "employment_marriage_market",
      "fallacy_type": "hasty_generalization",
      "argument_skeleton": "anecdote_or_limited_cases_to_group_claim",
      "statement_text": "看看婚恋市场，九成男性直接被审视资产底牌，大部分丈母娘们都默认男的没钱就不配娶女儿，因为在她们眼里男的就是提款机。",
      "issue_note": "目标谬误：hasty_generalization",
      "char_count": 57,
      "read_seconds_target": 7,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": true,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM010",
      "item_id": "FAM010_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW019"
      ],
      "topic_cluster": "gender_labor_value",
      "fallacy_type": "ad_hominem",
      "argument_skeleton": "source_attack_or_motive_dismissal",
      "statement_text": "如果没有父权社会兜底，没有亲老娘一点点扶持，没有新娘给他洗衣做饭下崽供养，大多数男的这辈子也就那样：普普通通浑浑噩噩，没有目标没有资产，在无人知晓的角落结束其平庸的一生。",
      "issue_note": "目标谬误：ad_hominem",
      "char_count": 85,
      "read_seconds_target": 10,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": true,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM010",
      "item_id": "FAM010_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW020"
      ],
      "topic_cluster": "gender_labor_value",
      "fallacy_type": "ad_hominem",
      "argument_skeleton": "source_attack_or_motive_dismissal",
      "statement_text": "如果没有女权这阵风，没有她爹妈拿钱供着，没有老公拿钱养着，大多数女的这辈子也就是浑浑噩噩，哪有什么“觉醒”，还好借着这阵风，给贪婪找了一堆借口。",
      "issue_note": "目标谬误：ad_hominem",
      "char_count": 72,
      "read_seconds_target": 8,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": true,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM011",
      "item_id": "FAM011_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW021"
      ],
      "topic_cluster": "gender_labor_value",
      "fallacy_type": "referential_scope",
      "argument_skeleton": "disqualifying_critic_by_identity_or_benefit_scope",
      "statement_text": "批评女性反歧视运动之前，先问问自己：你享受的现代生活，哪一天离得开女性劳动力？既然离不开，凭什么批评？",
      "issue_note": "目标谬误：referential_scope",
      "char_count": 51,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM011",
      "item_id": "FAM011_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW022"
      ],
      "topic_cluster": "gender_labor_value",
      "fallacy_type": "referential_scope",
      "argument_skeleton": "disqualifying_critic_by_identity_or_benefit_scope",
      "statement_text": "女权们一边上着国家、企业提供的职业岗位，一边骂人家打压她们，凭啥？",
      "issue_note": "目标谬误：referential_scope",
      "char_count": 33,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM012",
      "item_id": "FAM012_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW023"
      ],
      "topic_cluster": "housework_full_time_mother",
      "fallacy_type": "false_causation",
      "argument_skeleton": "single_factor_or_correlation_to_causal_claim",
      "statement_text": "全职妈妈补偿总引发争议，说明现在男的都认为养着他们的孩儿，做他们的饭是没有价值的工作。",
      "issue_note": "目标谬误：false_causation",
      "char_count": 43,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM012",
      "item_id": "FAM012_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW024"
      ],
      "topic_cluster": "housework_full_time_mother",
      "fallacy_type": "false_causation",
      "argument_skeleton": "single_factor_or_correlation_to_causal_claim",
      "statement_text": "家务补偿金额越来越高却仍被说不够，证明女权已经变味了，平权早就不是她们目标了，男人手中的钱才是。",
      "issue_note": "目标谬误：false_causation",
      "char_count": 48,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM013",
      "item_id": "FAM013_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW025"
      ],
      "topic_cluster": "housework_full_time_mother",
      "fallacy_type": "ad_hominem",
      "argument_skeleton": "source_attack_or_motive_dismissal",
      "statement_text": "把全职妈妈说成在家享福的，就是一辈子都懒得干活、自己妈估计都不体谅的男性。",
      "issue_note": "目标谬误：ad_hominem",
      "char_count": 37,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM013",
      "item_id": "FAM013_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW026"
      ],
      "topic_cluster": "housework_full_time_mother",
      "fallacy_type": "ad_hominem",
      "argument_skeleton": "source_attack_or_motive_dismissal",
      "statement_text": "把家务协商都说成女性被剥削的人，就不是想协商分工的，就是不想挣钱也不想参与劳动实践的女性。",
      "issue_note": "目标谬误：ad_hominem",
      "char_count": 45,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM014",
      "item_id": "FAM014_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW027"
      ],
      "topic_cluster": "harassment_reporting",
      "fallacy_type": "hasty_generalization",
      "argument_skeleton": "anecdote_or_limited_cases_to_group_claim",
      "statement_text": "高校偷拍和举报事件一件接一件地摆出来，早就说明了：大部分男性根本没觉得女生边界是回事。",
      "issue_note": "目标谬误：hasty_generalization",
      "char_count": 43,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": true,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM014",
      "item_id": "FAM014_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW028"
      ],
      "topic_cluster": "harassment_reporting",
      "fallacy_type": "hasty_generalization",
      "argument_skeleton": "anecdote_or_limited_cases_to_group_claim",
      "statement_text": "偷拍指控里总出现程序反转。提供给女性的举报机制已经被系统性全面利用了——不是为了求真，而是先把男性推上舆论审判台。",
      "issue_note": "目标谬误：hasty_generalization",
      "char_count": 57,
      "read_seconds_target": 7,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM015",
      "item_id": "FAM015_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW029"
      ],
      "topic_cluster": "harassment_reporting",
      "fallacy_type": "false_causation",
      "argument_skeleton": "single_factor_or_correlation_to_causal_claim",
      "statement_text": "骚扰举报每次都要在平台上带波愤怒，根子在于申诉机制长期摆设，逼着女性先把故事讲出去才有人当回事。",
      "issue_note": "目标谬误：false_causation",
      "char_count": 48,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM015",
      "item_id": "FAM015_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW030"
      ],
      "topic_cluster": "harassment_reporting",
      "fallacy_type": "false_causation",
      "argument_skeleton": "single_factor_or_correlation_to_causal_claim",
      "statement_text": "对男性的举报事件年年冲热搜、年年有争议，就是因为网络女权叙事已经把程序判断都变成了情绪表态比赛。",
      "issue_note": "目标谬误：false_causation",
      "char_count": 48,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM016",
      "item_id": "FAM016_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW031"
      ],
      "topic_cluster": "harassment_reporting",
      "fallacy_type": "ad_hominem",
      "argument_skeleton": "source_attack_or_motive_dismissal",
      "statement_text": "一个见到举报就先想程序漏洞的男人，大部分不过是在护着同类，他讲什么证据公正也只是服务立场。",
      "issue_note": "目标谬误：ad_hominem",
      "char_count": 45,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": true,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM016",
      "item_id": "FAM016_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW032"
      ],
      "topic_cluster": "harassment_reporting",
      "fallacy_type": "ad_hominem",
      "argument_skeleton": "source_attack_or_motive_dismissal",
      "statement_text": "一个性骚扰争议一出来就先喊支持受害者的人，多半只是想表演立场正确，她谈事实判断根本不可信。",
      "issue_note": "目标谬误：ad_hominem",
      "char_count": 45,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": false,
      "stats_flag": false,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM017",
      "item_id": "FAM017_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW033"
      ],
      "topic_cluster": "harassment_reporting",
      "fallacy_type": "referential_scope",
      "argument_skeleton": "disqualifying_critic_by_identity_or_benefit_scope",
      "statement_text": "反骚扰的讨论空间是女性推出来的，不少女生都受了这份惠——可她们又拿几起争议说女性爱构陷，说实话没资格。",
      "issue_note": "目标谬误：referential_scope",
      "char_count": 51,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM017",
      "item_id": "FAM017_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW034"
      ],
      "topic_cluster": "harassment_reporting",
      "fallacy_type": "referential_scope",
      "argument_skeleton": "disqualifying_critic_by_identity_or_benefit_scope",
      "statement_text": "女生享受程序正义和申诉机制的保护，但只要有男人对举报提出质疑，立刻被说厌女。享受保护的人，有什么资格给被机制压迫的人扣帽子？",
      "issue_note": "目标谬误：referential_scope",
      "char_count": 62,
      "read_seconds_target": 7,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM018",
      "item_id": "FAM018_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW035"
      ],
      "topic_cluster": "divorce_cooling_off",
      "fallacy_type": "hasty_generalization",
      "argument_skeleton": "anecdote_or_limited_cases_to_group_claim",
      "statement_text": "几起家暴受害者被离婚程序困住的案例，已经足以说明现行婚姻制度常把女性安全放在关系稳定之后。",
      "issue_note": "目标谬误：hasty_generalization",
      "char_count": 45,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM018",
      "item_id": "FAM018_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW036"
      ],
      "topic_cluster": "divorce_cooling_off",
      "fallacy_type": "hasty_generalization",
      "argument_skeleton": "anecdote_or_limited_cases_to_group_claim",
      "statement_text": "冷静期一出，立刻就有声音把极端个案升级成整套制度在压迫女性。冷静期根本问题就是给了女权一个搞对立的借口；她们不是真的关心受害者，只想要打掉冷静期。",
      "issue_note": "目标谬误：hasty_generalization",
      "char_count": 73,
      "read_seconds_target": 9,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM019",
      "item_id": "FAM019_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW037"
      ],
      "topic_cluster": "divorce_cooling_off",
      "fallacy_type": "false_causation",
      "argument_skeleton": "single_factor_or_correlation_to_causal_claim",
      "statement_text": "家暴受害者被离婚冷静期卡住出不去，这是偶然？到底是制度设计时根本没把人身安全当第一优先，而是优先婚姻维持。",
      "issue_note": "目标谬误：false_causation",
      "char_count": 53,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": false,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM019",
      "item_id": "FAM019_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW038"
      ],
      "topic_cluster": "divorce_cooling_off",
      "fallacy_type": "false_causation",
      "argument_skeleton": "single_factor_or_correlation_to_causal_claim",
      "statement_text": "每次离婚冷静期出现负面案例，女权话题就跟着爆；女权舆论正在把任何婚姻稳定机制都解释成压迫工具。",
      "issue_note": "目标谬误：false_causation",
      "char_count": 47,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM020",
      "item_id": "FAM020_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW039"
      ],
      "topic_cluster": "divorce_cooling_off",
      "fallacy_type": "ad_hominem",
      "argument_skeleton": "source_attack_or_motive_dismissal",
      "statement_text": "总有从来没被困在一段暴力关系里的人，开口就说冷静期对谁都有效；没被堵过路的人，讲什么通道畅通。",
      "issue_note": "目标谬误：ad_hominem",
      "char_count": 47,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": false,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM020",
      "item_id": "FAM020_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW040"
      ],
      "topic_cluster": "divorce_cooling_off",
      "fallacy_type": "ad_hominem",
      "argument_skeleton": "source_attack_or_motive_dismissal",
      "statement_text": "一个见到冷静期就说是父权压迫的人，多半只想把复杂法制问题道德化，她谈制度改良根本不可信。",
      "issue_note": "目标谬误：ad_hominem",
      "char_count": 44,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM021",
      "item_id": "FAM021_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW041"
      ],
      "topic_cluster": "divorce_cooling_off",
      "fallacy_type": "referential_scope",
      "argument_skeleton": "disqualifying_critic_by_identity_or_benefit_scope",
      "statement_text": "离婚自由是前人争来的，今天家暴受害者才能想走就走。说她们走得太急、破坏家庭的女生，你们靠谁的成果才有机会这样评价？",
      "issue_note": "目标谬误：referential_scope",
      "char_count": 57,
      "read_seconds_target": 7,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM021",
      "item_id": "FAM021_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW042"
      ],
      "topic_cluster": "divorce_cooling_off",
      "fallacy_type": "referential_scope",
      "argument_skeleton": "disqualifying_critic_by_identity_or_benefit_scope",
      "statement_text": "这些人享受法律提供的登记与裁判秩序，却把任何讨论程序平衡的意见都说成厌女；女权真有资格批评制度维护者？",
      "issue_note": "目标谬误：referential_scope",
      "char_count": 51,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM022",
      "item_id": "FAM022_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW043"
      ],
      "topic_cluster": "yang_li_gender_comedy",
      "fallacy_type": "hasty_generalization",
      "argument_skeleton": "anecdote_or_limited_cases_to_group_claim",
      "statement_text": "杨笠那几句普信男段子，换来的是压倒性的男性反扑——这已经很能说明问题：大部分男性对女性调侃有多低的容忍度。",
      "issue_note": "目标谬误：hasty_generalization",
      "char_count": 53,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": true,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM022",
      "item_id": "FAM022_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW044"
      ],
      "topic_cluster": "yang_li_gender_comedy",
      "fallacy_type": "hasty_generalization",
      "argument_skeleton": "anecdote_or_limited_cases_to_group_claim",
      "statement_text": "厌男梗和杨笠争议年年翻新，还说是真实诉求？不如说女权表达全靠贬低男性来维持热度。",
      "issue_note": "目标谬误：hasty_generalization",
      "char_count": 40,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM023",
      "item_id": "FAM023_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW045"
      ],
      "topic_cluster": "yang_li_gender_comedy",
      "fallacy_type": "ad_hominem",
      "argument_skeleton": "source_attack_or_motive_dismissal",
      "statement_text": "一个见到女生讲男性问题就说太偏激的男人，本来就不想让自己的习惯被挑战，他谈什么幽默和脱口秀的边界，压根不值得听。",
      "issue_note": "目标谬误：ad_hominem",
      "char_count": 56,
      "read_seconds_target": 7,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM023",
      "item_id": "FAM023_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW046"
      ],
      "topic_cluster": "yang_li_gender_comedy",
      "fallacy_type": "ad_hominem",
      "argument_skeleton": "source_attack_or_motive_dismissal",
      "statement_text": "一个逮着男性批评杨笠就喊玻璃心的人，讲什么理性讨论都没说服力，主业不是靠对立涨粉就是在卖焦虑。",
      "issue_note": "目标谬误：ad_hominem",
      "char_count": 47,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": true,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM024",
      "item_id": "FAM024_FEMINIST_LEANING",
      "item_role": "key",
      "stance_version": "feminist_leaning",
      "source_ids": [
        "NEW047"
      ],
      "topic_cluster": "yang_li_gender_comedy",
      "fallacy_type": "referential_scope",
      "argument_skeleton": "disqualifying_critic_by_identity_or_benefit_scope",
      "statement_text": "享用着女性争来的表达空间，却说今天的女权发声走了极端——用着她们争的成果，有些女生什么资格评判她们选择激烈表达的方式？",
      "issue_note": "目标谬误：referential_scope",
      "char_count": 59,
      "read_seconds_target": 7,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FAM024",
      "item_id": "FAM024_MALE_LEANING",
      "item_role": "key",
      "stance_version": "male_leaning",
      "source_ids": [
        "NEW048"
      ],
      "topic_cluster": "yang_li_gender_comedy",
      "fallacy_type": "referential_scope",
      "argument_skeleton": "disqualifying_critic_by_identity_or_benefit_scope",
      "statement_text": "靠性别对立吃流量的账号，却把男性的反感一律叫做脆弱——从这套机制里赚得最多的，没资格谈谁理性谁不理性。",
      "issue_note": "目标谬误：referential_scope",
      "char_count": 51,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": true,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": true
    },
    {
      "family_id": "FIL001",
      "item_id": "FIL001",
      "item_role": "filler",
      "stance_version": "common",
      "source_ids": [
        "NEW049"
      ],
      "topic_cluster": "bride_price_marriage_cost",
      "fallacy_type": "control_valid",
      "argument_skeleton": "balanced_contextual_reasoning",
      "statement_text": "聊彩礼的时候，别光盯着那些极端例子看，得结合当地的情况、双方的收入，还有两家协商的成本来综合说，这样才客观。",
      "issue_note": "平衡有效控制题，用于检查非谬误识别与反应质量",
      "char_count": 54,
      "read_seconds_target": 6,
      "evidence_type": "balanced_context",
      "conclusion_strength": "medium",
      "emotional_intensity": "low",
      "hostility_tone": "low",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": false,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": false,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": false
    },
    {
      "family_id": "FIL002",
      "item_id": "FIL002",
      "item_role": "filler",
      "stance_version": "common",
      "source_ids": [
        "NEW050"
      ],
      "topic_cluster": "child_surname",
      "fallacy_type": "control_valid",
      "argument_skeleton": "balanced_contextual_reasoning",
      "statement_text": "孩子跟爸爸姓还是妈妈姓，不是一句话能说清的，要看两家怎么商量、大家对法律的了解程度，还有老一辈的观念，单靠一个说法可解释不了所有人的选择。",
      "issue_note": "平衡有效控制题，用于检查非谬误识别与反应质量",
      "char_count": 69,
      "read_seconds_target": 8,
      "evidence_type": "balanced_context",
      "conclusion_strength": "medium",
      "emotional_intensity": "low",
      "hostility_tone": "low",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": false,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": false,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": false
    },
    {
      "family_id": "FIL003",
      "item_id": "FIL003",
      "item_role": "filler",
      "stance_version": "common",
      "source_ids": [
        "NEW051"
      ],
      "topic_cluster": "reproductive_autonomy",
      "fallacy_type": "control_valid",
      "argument_skeleton": "balanced_contextual_reasoning",
      "statement_text": "说到底，评价女性能不能用辅助生殖技术生孩子，不能只看一方面，得兼顾她自己的身体自主权、医疗资源够不够，还有相关制度的约束，这三点都得考虑到。",
      "issue_note": "平衡有效控制题，用于检查非谬误识别与反应质量",
      "char_count": 70,
      "read_seconds_target": 8,
      "evidence_type": "balanced_context",
      "conclusion_strength": "medium",
      "emotional_intensity": "low",
      "hostility_tone": "low",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": false,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": false
    },
    {
      "family_id": "FIL004",
      "item_id": "FIL004",
      "item_role": "filler",
      "stance_version": "common",
      "source_ids": [
        "NEW052"
      ],
      "topic_cluster": "parental_leave",
      "fallacy_type": "control_valid",
      "argument_skeleton": "balanced_contextual_reasoning",
      "statement_text": "产假政策好不好，不能光看假期多长，还得看企业负担、带娃支持和返岗保障。",
      "issue_note": "平衡有效控制题，用于检查非谬误识别与反应质量",
      "char_count": 35,
      "read_seconds_target": 6,
      "evidence_type": "balanced_context",
      "conclusion_strength": "medium",
      "emotional_intensity": "low",
      "hostility_tone": "low",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": false,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": false,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": false
    },
    {
      "family_id": "FIL005",
      "item_id": "FIL005",
      "item_role": "filler",
      "stance_version": "common",
      "source_ids": [
        "NEW053"
      ],
      "topic_cluster": "housework_full_time_mother",
      "fallacy_type": "control_valid",
      "argument_skeleton": "balanced_contextual_reasoning",
      "statement_text": "家务劳动到底值不值钱、该怎么算，当然可以拿出来聊，但每个家庭赚钱多少、谁有空、谁带孩子多，情况都不一样，不能用一套性别标准硬套所有人。",
      "issue_note": "平衡有效控制题，用于检查非谬误识别与反应质量",
      "char_count": 67,
      "read_seconds_target": 8,
      "evidence_type": "balanced_context",
      "conclusion_strength": "medium",
      "emotional_intensity": "low",
      "hostility_tone": "low",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": false,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": false,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": false
    },
    {
      "family_id": "FIL006",
      "item_id": "FIL006",
      "item_role": "filler",
      "stance_version": "common",
      "source_ids": [
        "NEW054"
      ],
      "topic_cluster": "harassment_reporting",
      "fallacy_type": "control_valid",
      "argument_skeleton": "balanced_contextual_reasoning",
      "statement_text": "处理骚扰举报，得让受害者敢发声，也要按程序公正调查，两头都顾到，比上来就急着站队、先骂谁对谁错更能避免争议。",
      "issue_note": "平衡有效控制题，用于检查非谬误识别与反应质量",
      "char_count": 54,
      "read_seconds_target": 6,
      "evidence_type": "balanced_context",
      "conclusion_strength": "medium",
      "emotional_intensity": "low",
      "hostility_tone": "low",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": false,
      "stats_flag": false,
      "case_flag": true,
      "mirror_match_flag": false,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": false
    },
    {
      "family_id": "FIL007",
      "item_id": "FIL007",
      "item_role": "filler",
      "stance_version": "common",
      "source_ids": [
        "NEW055"
      ],
      "topic_cluster": "divorce_cooling_off",
      "fallacy_type": "control_valid",
      "argument_skeleton": "balanced_contextual_reasoning",
      "statement_text": "聊离婚冷静期，得区分一般婚姻矛盾和家暴脱身这两种情况，不然结论容易跑偏。",
      "issue_note": "平衡有效控制题，用于检查非谬误识别与反应质量",
      "char_count": 36,
      "read_seconds_target": 6,
      "evidence_type": "balanced_context",
      "conclusion_strength": "medium",
      "emotional_intensity": "low",
      "hostility_tone": "low",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": false,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": false,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": false
    },
    {
      "family_id": "FIL008",
      "item_id": "FIL008",
      "item_role": "filler",
      "stance_version": "common",
      "source_ids": [
        "NEW056"
      ],
      "topic_cluster": "pay_gap",
      "fallacy_type": "control_valid",
      "argument_skeleton": "balanced_contextual_reasoning",
      "statement_text": "看男女薪酬差距，不能只抓着一点不放，岗位不一样、上班时长不一样、行业不一样，还有晋升通道不同，这些都得算进去，才能看全面。",
      "issue_note": "平衡有效控制题，用于检查非谬误识别与反应质量",
      "char_count": 61,
      "read_seconds_target": 7,
      "evidence_type": "balanced_context",
      "conclusion_strength": "medium",
      "emotional_intensity": "low",
      "hostility_tone": "low",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": false,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": false
    },
    {
      "family_id": "FIL009",
      "item_id": "FIL009",
      "item_role": "filler",
      "stance_version": "common",
      "source_ids": [
        "NEW057"
      ],
      "topic_cluster": "gender_risk",
      "fallacy_type": "control_valid",
      "argument_skeleton": "balanced_contextual_reasoning",
      "statement_text": "男性风险更高并不自动否定女性处境问题，两个命题可能同时成立。",
      "issue_note": "平衡有效控制题，用于检查非谬误识别与反应质量",
      "char_count": 30,
      "read_seconds_target": 6,
      "evidence_type": "balanced_context",
      "conclusion_strength": "medium",
      "emotional_intensity": "low",
      "hostility_tone": "low",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": false,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": false
    },
    {
      "family_id": "FIL010",
      "item_id": "FIL010",
      "item_role": "filler",
      "stance_version": "common",
      "source_ids": [
        "NEW058"
      ],
      "topic_cluster": "platform_algorithm",
      "fallacy_type": "control_valid",
      "argument_skeleton": "balanced_contextual_reasoning",
      "statement_text": "平台算法确实会放大那些有冲突的言论，但这并不代表所有说话的人都是为了制造仇恨。很多女性说到底，只是想解决现实里的实际问题而已。",
      "issue_note": "平衡有效控制题，用于检查非谬误识别与反应质量",
      "char_count": 63,
      "read_seconds_target": 7,
      "evidence_type": "balanced_context",
      "conclusion_strength": "medium",
      "emotional_intensity": "low",
      "hostility_tone": "low",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": false,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": false
    },
    {
      "family_id": "FIL011",
      "item_id": "FIL011",
      "item_role": "filler",
      "stance_version": "common",
      "source_ids": [
        "NEW059"
      ],
      "topic_cluster": "beauty_norms",
      "fallacy_type": "control_valid",
      "argument_skeleton": "balanced_contextual_reasoning",
      "statement_text": "聊“服美役”的时候，得分清三件事：个人喜好、社会给的奖励，还有环境的约束，别把这三者混为一谈，当成一回事来看待。",
      "issue_note": "平衡有效控制题，用于检查非谬误识别与反应质量",
      "char_count": 56,
      "read_seconds_target": 7,
      "evidence_type": "balanced_context",
      "conclusion_strength": "medium",
      "emotional_intensity": "low",
      "hostility_tone": "low",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": false,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": false,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": false
    },
    {
      "family_id": "FIL012",
      "item_id": "FIL012",
      "item_role": "filler",
      "stance_version": "common",
      "source_ids": [
        "NEW060"
      ],
      "topic_cluster": "child_custody",
      "fallacy_type": "control_valid",
      "argument_skeleton": "balanced_contextual_reasoning",
      "statement_text": "抚养、探视和监护，这三个在法律上不是一回事，层级不一样。聊到孩子的利益时，得分开说、分开处理，这样才合理。",
      "issue_note": "平衡有效控制题，用于检查非谬误识别与反应质量",
      "char_count": 53,
      "read_seconds_target": 6,
      "evidence_type": "balanced_context",
      "conclusion_strength": "medium",
      "emotional_intensity": "low",
      "hostility_tone": "low",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": false,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": false,
      "anchor_flag": false,
      "anchor_type": "",
      "needs_cross_rater": false
    },
    {
      "family_id": "ANC001",
      "item_id": "ANC001",
      "item_role": "anchor",
      "stance_version": "common",
      "source_ids": [
        "NEW061"
      ],
      "topic_cluster": "gender_policy",
      "fallacy_type": "false_causation",
      "argument_skeleton": "single_factor_or_correlation_to_causal_claim",
      "statement_text": "现在一方面鼓励大家生孩子，另一方面又给女性更多政策支持，说白了，就是社会资源正在明显向女性这边倾斜。",
      "issue_note": "目标谬误：false_causation",
      "char_count": 50,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": false,
      "anchor_flag": true,
      "anchor_type": "filter_anchor",
      "needs_cross_rater": false
    },
    {
      "family_id": "ANC002",
      "item_id": "ANC002",
      "item_role": "anchor",
      "stance_version": "common",
      "source_ids": [
        "NEW062"
      ],
      "topic_cluster": "pay_gap",
      "fallacy_type": "referential_scope",
      "argument_skeleton": "disqualifying_critic_by_identity_or_benefit_scope",
      "statement_text": "既然报告都说女性收入更低，那公司里同一个岗位，男性工资普遍更高，这事儿也没什么好怀疑的吧。",
      "issue_note": "目标谬误：referential_scope",
      "char_count": 45,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": false,
      "anchor_flag": true,
      "anchor_type": "filter_anchor",
      "needs_cross_rater": false
    },
    {
      "family_id": "ANC003",
      "item_id": "ANC003",
      "item_role": "anchor",
      "stance_version": "common",
      "source_ids": [
        "NEW063"
      ],
      "topic_cluster": "harassment_reporting",
      "fallacy_type": "hasty_generalization",
      "argument_skeleton": "anecdote_or_limited_cases_to_group_claim",
      "statement_text": "以前也有过举报反转的情况，所以现在看到这类指控，第一反应就该怀疑，是不是又有人来带节奏、博眼球了。",
      "issue_note": "目标谬误：hasty_generalization",
      "char_count": 49,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": false,
      "stats_flag": false,
      "case_flag": true,
      "mirror_match_flag": false,
      "anchor_flag": true,
      "anchor_type": "filter_anchor",
      "needs_cross_rater": false
    },
    {
      "family_id": "ANC004",
      "item_id": "ANC004",
      "item_role": "anchor",
      "stance_version": "common",
      "source_ids": [
        "NEW064"
      ],
      "topic_cluster": "housework_full_time_mother",
      "fallacy_type": "false_causation",
      "argument_skeleton": "single_factor_or_correlation_to_causal_claim",
      "statement_text": "全职妈妈离婚只补这么点钱，还不够说明婚姻制度本来就把女性的付出看得很轻吗？",
      "issue_note": "目标谬误：false_causation",
      "char_count": 37,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": false,
      "anchor_flag": true,
      "anchor_type": "filter_anchor",
      "needs_cross_rater": false
    },
    {
      "family_id": "ANC005",
      "item_id": "ANC005",
      "item_role": "anchor",
      "stance_version": "common",
      "source_ids": [
        "NEW065"
      ],
      "topic_cluster": "platform_algorithm",
      "fallacy_type": "ad_hominem",
      "argument_skeleton": "source_attack_or_motive_dismissal",
      "statement_text": "有些博主天天发男女对立内容，明显就是靠挑事吃流量，他们说的话根本不用认真分析。",
      "issue_note": "目标谬误：ad_hominem",
      "char_count": 39,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": true,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": false,
      "anchor_flag": true,
      "anchor_type": "filter_anchor",
      "needs_cross_rater": false
    },
    {
      "family_id": "ANC006",
      "item_id": "ANC006",
      "item_role": "anchor",
      "stance_version": "common",
      "source_ids": [
        "NEW066"
      ],
      "topic_cluster": "child_custody",
      "fallacy_type": "referential_scope",
      "argument_skeleton": "disqualifying_critic_by_identity_or_benefit_scope",
      "statement_text": "孩子最后判给谁，就说明谁在日常照顾里更负责，不然法院也不会这么安排。",
      "issue_note": "目标谬误：referential_scope",
      "char_count": 34,
      "read_seconds_target": 6,
      "evidence_type": "argument_claim",
      "conclusion_strength": "high",
      "emotional_intensity": "high",
      "hostility_tone": "medium",
      "familiarity": "medium",
      "specificity": "medium",
      "identity_label_flag": false,
      "stats_flag": false,
      "case_flag": false,
      "mirror_match_flag": false,
      "anchor_flag": true,
      "anchor_type": "filter_anchor",
      "needs_cross_rater": false
    }
  ]
}
